import {
  ScrollText,
  LineChart,
  Handshake,
  ClipboardSignature,
  GraduationCap,
  Compass,
  Target,
  Users,
} from "lucide-react";

export const services = [
  {
    slug: "policy-development",
    title: "Policy Development",
    short:
      "Plain-language HR policies and handbooks aligned with Ontario employment standards.",
    long: "We draft, refresh, and audit workplace policies — from accommodation and AODA to remote work, discipline, and health & safety — so your team has clear, compliant ground to stand on.",
    Icon: ScrollText,
  },
  {
    slug: "strategic-hr",
    title: "Strategic HR & People-Focused Financial Planning",
    short:
      "Workforce strategy and compensation planning rooted in your people, your budget, and your goals.",
    long: "We help leadership translate business strategy into headcount, total rewards, and people-focused financial models that protect culture without breaking the cash flow.",
    Icon: LineChart,
  },
  {
    slug: "union-labour-relations",
    title: "Union & Labour Relations",
    short:
      "Trusted day-to-day labour relations support for unionized workplaces.",
    long: "From grievance handling to LMC meetings, return-to-work, and arbitration prep, we work alongside your managers so labour relations becomes a relationship — not a crisis.",
    Icon: Handshake,
  },
  {
    slug: "collective-agreement-negotiations",
    title: "Collective Agreement Negotiations",
    short:
      "Bargaining preparation, costing, and at-the-table support for first and renewal CAs.",
    long: "We build your bargaining mandate, cost proposals, prepare your team, and sit at the table with you. Calm, prepared, evidence-based negotiations.",
    Icon: ClipboardSignature,
  },
  {
    slug: "training-plans",
    title: "Training Plans",
    short:
      "Practical learning roadmaps that build skills people actually use on Monday.",
    long: "We design training plans for new managers, frontline supervisors, and full teams — covering respect at work, accommodation, performance conversations, and labour relations basics.",
    Icon: GraduationCap,
  },
  {
    slug: "leadership-coaching",
    title: "Leadership Coaching",
    short:
      "1:1 coaching for owners, executives, and people-leaders navigating change.",
    long: "Confidential coaching for leaders who carry HR on top of everything else — building confidence around difficult conversations, decisions, and team dynamics.",
    Icon: Compass,
  },
  {
    slug: "performance-planning",
    title: "Performance Planning",
    short:
      "Clear performance frameworks that move beyond annual reviews.",
    long: "We build performance planning rhythms — goals, check-ins, feedback, and documentation — that managers can sustain and employees actually trust.",
    Icon: Target,
  },
  {
    slug: "capacity-building",
    title: "Capacity Building Partnership",
    short:
      "We work alongside your team to grow their HR knowledge and confidence.",
    long: "Instead of doing it for you, we do it with you. Ongoing partnership, embedded support, and knowledge transfer so your team is stronger after we step back.",
    Icon: Users,
  },
];

export const industries = [
  {
    slug: "new-businesses",
    title: "New Businesses",
    description:
      "You're hiring your first employees and need to get the foundation right — contracts, policies, and a workplace people want to stay in.",
  },
  {
    slug: "small-business-no-hr",
    title: "Small Businesses Without Dedicated HR",
    description:
      "You have a team, but HR lives on the owner's or office manager's desk. We become your part-time HR partner without the full-time overhead.",
  },
  {
    slug: "newly-unionized",
    title: "Newly Unionized Organizations",
    description:
      "Your workplace was just certified. We help you navigate first-contract negotiations and shift from informal practices to a structured labour relations model.",
  },
  {
    slug: "medium-businesses",
    title: "Medium-Sized Businesses",
    description:
      "You have HR in-house, but need strategic capacity for bargaining, policy overhauls, leadership coaching, or sensitive investigations.",
  },
];

export const valueProps = [
  {
    title: "Alongside, not above",
    body:
      "We sit shoulder-to-shoulder with your team. Knowledge transfer is built into every engagement.",
  },
  {
    title: "Ontario-rooted expertise",
    body:
      "Deep familiarity with the ESA, OHRC, and the Labour Relations Act — applied with judgment, not jargon.",
  },
  {
    title: "Human before policy",
    body:
      "Policies and processes should serve the people who use them. We design for the human first.",
  },
];
